import { useQuery } from '@tanstack/react-query';
import {
  fetchDashboardKpis,
  type DashboardKpisQuery,
} from '@/services/api/dashboard.api';

export function useDashboardKpis(query: DashboardKpisQuery) {
  return useQuery({
    queryKey: ['dashboard', 'kpis', query],
    queryFn: () => fetchDashboardKpis(query),
    enabled: !!query.propertyId,
    staleTime: 60_000,
  });
}
